<template>
    <div :class="classes" class="flex-column hp-10 flex prelative min-h-350">
        <SellsyListing
            :enableFiltering="false"
            :enableExport="more.enableExport"
            endpoint=""
            :linkedtype="more.linkedtype"
            :name="more.name"
            :url="more.url"
            :use-favorites="false"
            :prefilter="prefilter"
            :buttons="buttons"
            :related-permissions="permissions"
        >
            <template #header>
                {{ more.title }}
            </template>
        </SellsyListing>
    </div>
</template>

<script>
import { buildUrl } from '../../../helpers';
import SellsyListing from 'vcomponents/listing/Listing.vue';
import Feature from 'Services/Feature';

export default {
    components: {
        SellsyListing,
    },
    props: {
        more: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            openOppForm: false,
            itemId: false,
            mode: 'read',
            buttons: this.more?.buttons ?? [],
        };
    },
    computed: {
        classes() {
            return {
                'tab-listing': this.showNewVersion,
            };
        },
        showNewVersion() {
            return Feature.isEnabled('overview-info-sidebar');
        },
        prefilter() {
            return {
                third: {
                    mode: 'is',
                    value: this.$store.getters.linkedid,
                },
            };
        },
        permissions() {
            return this.$store.getters.permissions;
        },
    },
    created() {
        this.buttons.map((button) => {
            button.linkedid = this.$store.getters.linkedid;
            button.linkedtype = this.$store.getters.linkedtype;
            button.disabled =
                button.permission && button.permission != '' && this.permissions[button.permission]
                    ? false
                    : true;
        });
    },
    methods: {
        buildUrl,
    },
};
</script>
<style lang="scss" scoped>
.tab-listing {
    display: flex;
    flex: 1;
    flex-direction: column;
    padding: var(--spacing-4) 0 0;
}
</style>
